import { atom } from "recoil";

export const totalScanDataState = atom({
  default: [],
  key: "totalScanDataState",
});
